import { Component, Input } from '@angular/core';
import { RoleMatrix } from '../../../../helpers';

@Component({
    selector: 'app-breadcrumb-wo-bulk-changes',
    templateUrl: './breadcrumb.work.order.bulk.changes.component.html'
})

export class BreadcrumbWorkOrderBulkChangesComponent {

    roleMatrix: RoleMatrix;

    @Input() companyId: number;
    @Input() viewType: string;

    constructor() {
        this.roleMatrix = new RoleMatrix();
    }
}
